
import {useEffect} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import NavHeader from '../shared/Nav-Header';
import { useState, useMemo } from 'react';
import styles from './offer-view.module.css';
import defaultProfile from '../images/default-profile1.jpg';
import Notification from '../shared/Notification';
import {formatDistanceToNow} from 'date-fns';
import { useAuth } from '../context/AuthContext';


const OfferView = () => {
    const { userId } = useAuth();
    const { offerId } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const profileId = queryParams.get('profileId') || '';
    const profileType = queryParams.get('profileType') || '';
    const [offerDetails, setOfferDetails] = useState(null);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const [createdDate, setCreatedDate] = useState('');
    const [dateJoined, setDateJoined] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);
    const [lastOnline, setLastOnline] = useState('');
    // console.log('OfferView params:', profileId, profileType);
    let offerMaker;

    useEffect(() => {
        const fetchOfferDetails = async () => {
            // console.log('Fetching offer details for offerId:merilite-app', offerId, 'profileId:', profileId, 'profileType:', profileType, 'userId', userId);
            try {
                const response = await axios.get(`/api/learn-teach/offer/${offerId}`, {
                    params: { profileId,
                        profileType },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log('Offer details fetched:', response.data);
            
                if (profileType === 'sender'|| profileType === 'receiver') {
                    
                    setOfferDetails(response.data);
                    // console.log('Offer details set:', response.data);
                    setCreatedDate(formatDistanceToNow(new Date(response.data.createdAt), {addSuffix: true}))
                    setDateJoined(formatDistanceToNow(new Date(response.data.receiverId.dateJoined ||response.data.senderId.dateJoined), {addSuffix: true}))
                }
                let offer;
                if (profileType === 'connected') {

                    offer = response.data;
                    let connectedUser;
                    // let offerMaker;
                    offerMaker =typeof offer.senderId === 'object' 
                        ? true : false; 
                    connectedUser = typeof offer.senderId === 'object' 
                        ? offer.senderId 
                        : offer.receiverId;
                    setOfferDetails({...offer, connectedUser});
                    if (connectedUser?.dateJoined) {
                        setDateJoined(formatDistanceToNow(new Date(connectedUser.dateJoined), { addSuffix: true }));
                    }            
                    setCreatedDate(formatDistanceToNow(new Date(offer.createdAt), { addSuffix: true }));

            }
                       
            
            
                
            } catch (error) {
                // console.error('Error fetching offer details:', error);
            if(error.response?.status === 403){
                setNotification(error.response.data.message ||'');
                // console.log(error.response.data.message || '');
            }
            }
        };

        fetchOfferDetails();
    }, [offerId, profileId]);

    // console.log('Offer Details State:', offerDetails);
    const handleWithdrawOffer = () => async () => {
        try {
            const response = await axios.delete(`/api/learn-teach/withdraw/${offerId}`,
                {params: { profileId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }

            );
            // console.log('Withdraw offer response:', response.data);
            if (response.data.success) {
                // setOfferDetails(null);
                setNotification('Offer withdrawn successfully');
                setTimeout(() => {
                    navigate(-1);
                }, 3000);
            }
        } catch (error) {
            // console.error('Error withdrawing offer:', error.message);
            if(error.response?.status === 403){
                setNotification(error.response.data.message ||'');
                // console.log(error.response.data.message || '');
            }
        }
    };

    const handleDeleteOffer = () => async () => {
        try {
            const response = await axios.delete(`/api/learn-teach/delete/${offerId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            // console.log('Delete offer response:', response.data);
            if (response.data.success) {
                // setOfferDetails(null);
                setNotification('Offer deleted successfully');
                setTimeout(() => {
                    navigate(-1);
                }, 3000);
            }
        }
        catch (error) {
            // console.error('Error deleting offer:', error.message);
            if(error.response?.status === 403){
                setNotification(error.response.data.message ||'');
                // console.log(error.response.data.message || '');
            }
        }
    }

    const handleAcceptOffer = () => async () => {
        // console.log('Accept offer clicked', offerId);
        try {
            const response = await axios.post(`/api/learn-teach/accept/${offerId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            // console.log('accept offer response:', response.data);
            if (response.data.success) {
                // setOfferDetails(null);
                setNotification('Offer accepted successfully');
                setTimeout(() => {
                    navigate(-1);
                }, 3000);
            }
        }
        catch (error) {
            // console.error('Error accepting offer:', error.message);
            if(error.response?.status === 403){
                setNotification(error.response.data.message ||'');
                // console.log(error.response.data.message || '');
            }
        }
    }
    const handleDeleteConnection = () => async () => {
        try {
            const response = await axios.delete(`/api/learn-teach/delete-connection/${offerId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            // console.log('Delete connection response:', response.data);
            if (response.data.success) {
                // setOfferDetails(null);
                setNotification('Connection deleted successfully');
                setTimeout(() => {
                    navigate(-1);
                }, 3000);
            }
        }
        catch (error) {
            // console.error('Error deleting connection:', error.message);
            if(error.response?.status === 403){
                setNotification(error.response.data.message ||'');
                // console.log(error.response.data.message || '');
            }
        }
    };

    const handleProfileClick1 = () => () => {
        navigate(`/profile/${offerDetails.senderId?._id}`);
    };
    const handleProfileClick2 = () => () => {
        navigate(`/profile/${offerDetails.receiverId?._id}`);
    };
    const handleProfileClick = () => () => {
        navigate(`/profile/${offerDetails.connectedUser?._id}`);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    return (
        <div>
            <NavHeader />
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            <div className={styles.offerViewContainer}>
                {offerDetails &&
                    <div className={styles.offerDetails}>
                        {profileType === 'sender'  && (
                            <div>
                                <h2>Received Offer Details</h2>
                                <div className={styles.offerActions}>
                                    <button onClick={handleDeleteOffer()} className={styles.deleteButton}>Delete</button>
                                    <button onClick={handleAcceptOffer()} className={styles.acceptButton}>Accept</button>
                                </div>
                                <i>(They want)</i>
                                <p><strong>To Learn:</strong> {offerDetails.toLearn.join(', ')}</p>
                                <p><strong>To Teach:</strong> {offerDetails.toTeach.join(', ')}</p>
                                <p><strong>Language:</strong> {offerDetails.language}</p>
                                <p className={styles.status}>
                                <strong>Status:</strong>{''}
                                    <span className={styles[`status${offerDetails.status.charAt(0).toUpperCase() + offerDetails.status.slice(1)}`]}>{offerDetails.status.charAt(0).toUpperCase() + offerDetails.status.slice(1)}</span>
                                </p>
                                <p><strong>Created:</strong> {createdDate}</p>
                                <h3>Senders' Profile</h3>
                                <div onClick={handleProfileClick1()} className={styles.offerSenderProfileDetails}>
                                    <p><strong>Name:</strong><span className={styles.name}> {offerDetails.senderId?.name}</span></p>
                                    <img title={offerDetails.senderId?.name} src={offerDetails.senderId?.profilePicture ? offerDetails.senderId?.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile} alt={`${offerDetails.senderId?.name}'s profile`} className={styles.profilePicture} />
                                    <p>Learning-Teaching Completed:{offerDetails.senderId?.learningTeachingCompleted}</p>
                                    <p>DateJoined: {dateJoined}</p>
                                    <p><strong>About:</strong> {offerDetails.senderId?.about}</p>
                                </div>
                            </div>
                        )}
                        {profileType === 'receiver'  && (
                            <div>
                                <h2>Sent Offer Details</h2><div className={styles.offerActions}>
                                    <button onClick={handleWithdrawOffer()} className={styles.withdrawButton}>Withdraw</button>
                                </div>
                                <p><strong>To Learn:</strong> {offerDetails.toLearn.join(', ')}</p>
                                <p><strong>To Teach:</strong> {offerDetails.toTeach.join(', ')}</p>
                                <p><strong>Language:</strong> {offerDetails.language}</p>
                                <p className={styles.status}>
                                <strong>Status:</strong>{''}
                                    <span className={styles[`status${offerDetails.status.charAt(0).toUpperCase() + offerDetails.status.slice(1)}`]}>{offerDetails.status.charAt(0).toUpperCase() + offerDetails.status.slice(1)}</span>
                                </p>
                                <p><strong>Created:</strong> {createdDate}</p>
                                <div onClick={handleProfileClick2()} className={styles.receiverProfileDetails}>
                                    <h3>Receivers' Profile</h3>
                                    <p><strong>Name:</strong> <span className={styles.name}>{offerDetails.receiverId?.name} </span></p>
                                    <img title={offerDetails.receiverId?.name} src={offerDetails.receiverId?.profilePicture ? offerDetails.receiverId?.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile} alt={`${offerDetails.receiverId?.name}'s profile`} className={styles.profilePicture} />
                                    <p>Learning-Teaching Completed: {offerDetails.receiverId?.learningTeachingCompleted}</p>
                                    <p>DateJoined: {dateJoined}</p>
                                    <p><strong>About:</strong> {offerDetails.receiverId?.about? offerDetails.receiverId?.about : 'N/A'}</p>
                                </div>
                            </div>
                        )}
                        {profileType === 'connected'  && (
                            <div className={styles.connectedOfferDetails}>
                                <h2>Connected Offer Details</h2>
                                <div className={styles.deleteButtonContainer}>
                                    <button  onClick={handleDeleteConnection()} className={styles.deleteConnection} title='Delete Connection'>X</button>
                                </div>
                                {offerMaker ?<>
                                <i>(I want)</i>
                                    <p><strong>To Learn:</strong> {offerDetails.toLearn.join(', ')}</p>
                                    <p><strong>To Teach:</strong> {offerDetails.toTeach.join(', ')}</p>
                                </>:
                                <>
                                <i>(I want)</i>
                                    <p><strong>To Learn:</strong> {offerDetails.toTeach.join(', ')}</p>
                                    <p><strong>To Teach:</strong> {offerDetails.toLearn.join(', ')}</p>
                                </>}
                                <p><strong>Language:</strong> {offerDetails.language}</p>
                                <p className={styles.status}>
                                <strong>Status:</strong>{''}
                                    <span className={styles[`status${offerDetails.status.charAt(0).toUpperCase() + offerDetails.status.slice(1)}`]}>{offerDetails.status.charAt(0).toUpperCase() + offerDetails.status.slice(1)}</span>
                                </p>
                                <p><strong>Created:</strong> {createdDate}</p>
                                <div onClick={handleProfileClick()} className={styles.receiverProfileDetails}>
                                    <h3>Connections' Profile</h3>
                                    <p><strong>Name:</strong> <span className={styles.name}>{offerDetails.connectedUser?.name} </span></p>
                                    <img title={offerDetails.connectedUser?.name} src={offerDetails.connectedUser?.profilePicture ? offerDetails.connectedUser?.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile} alt={`${offerDetails.connectedUser?.name}'s profile`} className={styles.profilePicture} />
                                    <p>Learning-Teaching Completed: {offerDetails.connectedUser?.learningTeachingCompleted}</p>
                                    <p>DateJoined: {dateJoined}</p>
                                    <p><strong>About:</strong> {offerDetails.connectedUser?.about? offerDetails.connectedUser?.about : 'N/A'}</p>
                                </div>
                            </div>
                        )}
                    </div>
                }
            </div>
        </div>
    );
}
export default OfferView;